var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#E2E8F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50298 16.2501C6.1756 16.2501 5.89544 16.1337 5.6625 15.9007C5.42917 15.6674 5.3125 15.387 5.3125 15.0596V9.10726C5.3125 8.77988 5.42917 8.49953 5.6625 8.26619C5.89544 8.03326 6.1756 7.91679 6.50298 7.91679H7.09821V6.72631C7.09821 5.9029 7.38849 5.20092 7.96905 4.62036C8.54921 4.0402 9.25099 3.75012 10.0744 3.75012C10.8978 3.75012 11.5998 4.0402 12.1804 4.62036C12.7605 5.20092 13.0506 5.9029 13.0506 6.72631V7.91679H13.6458C13.9732 7.91679 14.2536 8.03326 14.4869 8.26619C14.7198 8.49953 14.8363 8.77988 14.8363 9.10726V15.0596C14.8363 15.387 14.7198 15.6674 14.4869 15.9007C14.2536 16.1337 13.9732 16.2501 13.6458 16.2501H6.50298ZM10.0744 13.2739C10.4018 13.2739 10.6821 13.1575 10.9155 12.9245C11.1484 12.6912 11.2649 12.4108 11.2649 12.0835C11.2649 11.7561 11.1484 11.4757 10.9155 11.2424C10.6821 11.0094 10.4018 10.893 10.0744 10.893C9.74702 10.893 9.46687 11.0094 9.23393 11.2424C9.0006 11.4757 8.88393 11.7561 8.88393 12.0835C8.88393 12.4108 9.0006 12.6912 9.23393 12.9245C9.46687 13.1575 9.74702 13.2739 10.0744 13.2739ZM8.28869 7.91679H11.8601V6.72631C11.8601 6.23028 11.6865 5.80865 11.3393 5.46143C10.9921 5.11421 10.5704 4.9406 10.0744 4.9406C9.57837 4.9406 9.15675 5.11421 8.80952 5.46143C8.4623 5.80865 8.28869 6.23028 8.28869 6.72631V7.91679Z",
    fill: "#1A202C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.d26e6f3910082e349f7f43e6400ee02d.svg";
export { ForwardRef as ReactComponent };